import React from 'react';
import {IndexLink,Link, withRouter} from 'react-router';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from 'axios';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
let querystring = require('querystring');
import {Player, BigPlayButton, ControlBar} from 'video-react';

import ReactGA from 'react-ga';

import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import * as commonApi from "../../../api/common-api";
import * as userApi from "../../../api/user-api";
import ShowMoreText from 'react-show-more-text';

const styles = {
    title: {
        fontSize: '14px',
        color: '#4d4d4d',
        fontWeight: '600',
        marginBottom: '10px',
    },
    iconStyle: {
        width: '18px',
        height: '18px',
        marginRight: '5px'
    },
    labelStyle: {
        lineHeight: '16px',
        fontFamily: 'inherit',
        fontSize: '13px',
        color: '#000',
        width: 'auto'
    },
};

class BoostJob extends React.Component{
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            //layout of right
            is_mobile: false,
            //budget
            opt_budget: [],
            cards: [],
            budgets: {
                budget: 1,
                budget_daily: '25.00',
                budget_total: 0,
                schedule: '',
                schedule_start: null,
                schedule_start_date: null,
                schedule_end_date: null,
                bid: '1.00',
            },
			lst_errors: [],
        };
    }

    componentWillMount() {
        this.getBudget();
        this.getCreditPayment();
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {}

    getBudget() {
        this.setState({loading: true});
        let url = "/code/apis.php?api=getParams&opt_param=budget";
        let data = new FormData();
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({ opt_budget: response.data.data });
                }
                return response;
            }).catch(error => {
        });
    }

    getCreditPayment () {
        let url = '/code/api_jobs.php?api=preCreditPayment';
        let data = new FormData();
        axios.post(url, data)
            .then(response => {
                let cards = [];
                if (response.data.status >= 1) {
                    let cardLst = response.data.data;
                    for (let index = 0; index < cardLst.length; ++index) {
                        let card = cardLst[index];
                        if (card.default_card === '1') {
                            let img_card = "/static/img/appimg/"+card.card_type+".png";
                            cards.push(<span><img src={img_card} className={"align-middle"}/>{card.card_type} ending in {card.card_last4}  <Link to={"/update-credit"} target="_blank">Change</Link></span>);
                        }
                    }
                }
                if (cards.length <= 0) cards.push(<div><span>Please add your payment method  </span> <Link to={"/payment/setting"} target="_blank">Add</Link></div>)
                this.setState({cards: cards});
            }).catch(error => {});
    }

    //budget
    handleCalendarChange (propertyName, event) {
        const budgets = this.state.budgets;
        budgets[propertyName] = event;
        this.setState(Object.assign({}, budgets));
    }

    handleTextChange (propertyName, event) {
        const budgets = this.state.budgets;
        budgets[propertyName] = event.target.value;
        this.setState(Object.assign({}, budgets));
    }

    handleSelectChange (propertyName, event) {
        const budgets = this.state.budgets;
        budgets[propertyName] = event.value;
        budgets['budget_daily'] = event.value==1?25.00:0;
        budgets['budget_total'] = 0;
        this.setState(Object.assign({}, budgets));
    }

    handleRadioChange (propertyName, radioValue, event) {
        const budgets = this.state.budgets;
        budgets[propertyName] = radioValue;
        if (radioValue === 1) {
            budgets['schedule_start_date'] = null;
            budgets['schedule_end_date'] = null;
        }
        else if (radioValue === 2) {
            budgets['schedule_start'] = null;
        }

        this.setState(Object.assign({}, budgets));
    }

    handleClose = (event) => {
        this.props.handleClose();
    }

    handleSubmit = (event) => {
		let have_errors = 0;
		let lst_errors = this.state.lst_errors;
		
		let budget_daily = parseInt(this.state.budgets['budget_daily']) || 0
		let budget_total = parseInt(this.state.budgets['budget_total']) || 0
		let bid = parseInt(this.state.budgets['bid']) || 0
		
		if (budget_daily <= 0 && budget_total <= 0) {
			lst_errors["budget_daily_error"] = "Required";
			have_errors = 1;
		}
		
		if (this.state.budgets['schedule'] === '' ) {
			lst_errors["schedule_error"] = "Required";
			have_errors = 1;
		}
		
		if (bid <= 0) {
			lst_errors["bid_error"] = "Required";
			have_errors = 1;
		}
		console.log(lst_errors);
		if (have_errors === 1) {
			this.setState({lst_errors: lst_errors});
			return false;
		}
		
        let schedule_start_date = this.state.budgets.schedule_start_date != null ? this.state.budgets.schedule_start_date.format("YYYY-MM-DD") : null;

        if (this.state.budgets.schedule === 1) {
            schedule_start_date = this.state.budgets.schedule_start != null ? this.state.budgets.schedule_start.format("YYYY-MM-DD") : null;
        }

        let params = Object.assign({},
            {
                jobs_id: this.props.jobs_id,
                budget: this.state.budgets.budget,
                budget_daily: this.state.budgets.budget_daily,
                budget_total: this.state.budgets.budget_total,
                schedule: this.state.budgets.schedule,
                schedule_start_date: schedule_start_date,
                schedule_end_date: this.state.budgets.schedule_end_date != null ? this.state.budgets.schedule_end_date.format("YYYY-MM-DD") : null,
                bid: this.state.budgets.bid,
                bid_id: this.props.feeditem.bid_id,
            }
        );

        axios.post('/code/api_feeds.php?api=updateBid', querystring.stringify(params))
            .then(response => {
                if (response.data.status == 1) {
                    this.props.handleBoostSubmit();
                    //commonApi.showAlert("Your ads has been updated!");
                }
                else {
                    commonApi.showAlert("Please try again!");
                }
            });
    }

    //layout

    handleClickMobile = (mobile) => {
        this.setState({is_mobile: mobile});
    }

    executeOnClick = (isExpanded) => {
        console.log(isExpanded);
    }

    render() {
        let videoUrl = <img src={this.props.feeditem.imgUrl}/>
        if (this.props.feeditem.job_video_file) {
            videoUrl= <PlayerTest videoUrl={this.props.feeditem.job_video_file.link_file}/>
            if (this.props.feeditem.job_video==2) {
                videoUrl = <img src={this.props.feeditem.job_video_file.link_file}/>
            }
        }

        let onsite = '';
        if (this.props.feeditem.job_tracking != '') {
            onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> One-Click Apply </a>;
            if (this.props.feeditem.job_tracking_url != '') {
                onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> Apply on Site </a>;
            }
            if (this.props.feeditem.job_tracking == '1') {
                onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> Apply </a>;
            }
        }

        const context = <div
            dangerouslySetInnerHTML={{__html: this.props.feeditem.des_job}}>
        </div>;

        return (
            <div id={"job-create"} className={'item clear'}>
                <button className="close" onClick={this.handleClose.bind(this)}>X</button>
                <h2>Budget & Schedule</h2>
                <div className={"col-xs-12 content-block pd0"}>
                    <div className={"col-xs-5 content-left pl0"}>
                        <div className={"col-xs-12 pd0"}>
                            {this.props.feeditem.bid_id>0?<p><span className="glyphicon glyphicon-info-sign"></span> You've currently running a boost for this job post.<br/><Link to={"/campaign"}>Review your active ads</Link></p>:""}
                            <label className="t-lab t-lab-b">Budget</label>
                            <Select
                                name="budget"
                                className={"col-xs-8 pd0"}
                                value={this.state.budgets.budget}
                                options={this.state.opt_budget}
                                onChange={this.handleSelectChange.bind(this, 'budget')}
                                clearable={false}
                                searchable={false}
                                placeholder="Set a daily budget"
                            />
                        </div>
                        <div className={this.state.budgets.budget==1?"col-xs-12 pl10 pr0":'hide-el'}>
                            <label className="t-lab t-lab-b">Daily Budget</label>
                            <div className={"col-xs-3 pd0"}>
                                <input
                                    type="text"
                                    value={this.state.budgets.budget_daily}
                                    onChange={this.handleTextChange.bind(this, 'budget_daily')}
                                    className="form-control text-right"
                                    placeholder="$25.00"
                                />
                            </div>
                            <div className={"col-xs-9 pd0"}>
                                <p className="t-lab-l">Actual daily spend may be up to 20% hight</p>
                            </div>
                        </div>
                        <div className={this.state.budgets.budget==2?"col-xs-12 pl10 pr0":'hide-el'}>
                            <label className="t-lab t-lab-b">Total Budget</label>
                            <div className={"col-xs-3 pd0"}>
                                <input
                                    type="text"
                                    value={this.state.budgets.budget_total}
                                    onChange={this.handleTextChange.bind(this, 'budget_total')}
                                    className="form-control text-right"
                                    placeholder="$250.00"
                                />
                            </div>
                        </div>
                        <div className={"col-xs-12 pd0"}>
                            <div className={"col-xs-12 pd0"}>
                                <label className="t-lab t-lab-b">Schedule</label>
                            </div>
                            <div className={"col-xs-12 pd0"}>
                                <RadioButton
                                    label="Run campaign continuously from a start date"
                                    onClick={this.handleRadioChange.bind(this, 'schedule', 1)}
                                    checked={this.state.budgets.schedule===1?true:false}
                                    className="radioButton"
                                    iconStyle={styles.iconStyle}
                                    labelStyle={styles.labelStyle}
                                />
                            </div>
                            <div className={this.state.budgets.schedule===1?"col-xs-4 pl10 pr0 pb pb10":"hide-el"}>
                                <label className="t-lab t-lab-b">Start date</label>
                                <DatePicker
                                    selected={this.state.budgets.schedule_start !== '' ? this.state.budgets.schedule_start : null}
                                    onChange={this.handleCalendarChange.bind(this, 'schedule_start')}
                                    placeholderText="MM/DD/YY"
                                    className="form-control input-md job-calendar"
                                    style={{marginTop: '10px', width: '30%'}}
                                />
                            </div>
                            <div className={"col-xs-12 pd0"}>
                                <RadioButton
                                    label="Set a start and end date"
                                    onClick={this.handleRadioChange.bind(this, 'schedule', 2)}
                                    checked={this.state.budgets.schedule===2?true:false}
                                    className="radioButton"
                                    iconStyle={styles.iconStyle}
                                    labelStyle={styles.labelStyle}
                                />
                            </div>
                            <div className={this.state.budgets.schedule===2?"col-xs-12 pd0":"hide-el"}>
                                <div className={"col-xs-4 pl10 pr0 pb pb10"}>
                                    <label className="t-lab t-lab-b">Start date</label>
                                    <DatePicker
                                        selected={this.state.budgets.schedule_start_date !== '' ? this.state.budgets.schedule_start_date : null}
                                        onChange={this.handleCalendarChange.bind(this, 'schedule_start_date')}
                                        placeholderText="MM/DD/YY"
                                        className="form-control input-md job-calendar"
                                        style={{marginTop: '10px', width: '30%'}}
                                    />
                                </div>
                                <div className={"col-xs-4 pl10 pr0 pb pb10"}>
                                    <label className="t-lab t-lab-b">End date</label>
                                    <DatePicker
                                        selected={this.state.budgets.schedule_end_date !== '' ? this.state.budgets.schedule_end_date : null}
                                        onChange={this.handleCalendarChange.bind(this, 'schedule_end_date')}
                                        placeholderText="MM/DD/YY"
                                        className="form-control input-md job-calendar"
                                        style={{marginTop: '10px', width: '30%'}}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={"col-xs-12 pd0"}>
                            <label className="t-lab t-lab-b">Bid type</label>
                            <div className={"col-xs-5 pd0"}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Maximum CPC Bid"
                                    disabled={true}
                                />
                            </div>
                            <div className={"col-xs-12 pd0"}>
                                <p className="pt5 t-lab-b">I will adjust my CPC (cost per click) bid manually.</p>
                            </div>
                        </div>
                        <div className={"col-xs-12 pl10"}>
                            <div className={"col-xs-12 pd0"}>
                                <label className="t-lab t-lab-b">Bid amount</label>
                            </div>
                            <div className={"col-xs-4 pd0"}>
                                <input
                                    type="text"
                                    value={this.state.budgets.bid}
                                    onChange={this.handleTextChange.bind(this, 'bid')}
                                    className="form-control text-right"
                                    placeholder="$1.00"
                                />
                            </div>
                            <div className={"col-xs-5 pd0"}>
                                <p className="t-lab-l">per click</p>
                            </div>
                            <div className={"col-xs-12 pd0"}>
                                <p className="pb5 pt5">Recommended bid: $2.00</p>
                                <p className="pb5">Other similar advertisers are bidding between $2.00 - $2.30</p>
                                {(this.state.budgets.bid != '' && this.state.budgets.bid < 1)?<p className="pb5 t-red">Bid needs to be at least: $1.00</p>:''}
                            </div>
                        </div>
                        <div className={"col-xs-12 pl10"}>
                            <div className={"col-xs-12 pd0"}>
                                <label className="t-lab t-lab-b">Payment Method</label>
                            </div>
                            {this.state.cards}
                        </div>
                    </div>
                    <div className={"col-xs-7 pd0"}>
                        <div className={'top_content'}>
                            <div className={this.state.is_mobile?'':'active'} onClick={this.handleClickMobile.bind(this, false)}>Desktop News Feed</div>
                            <div className={this.state.is_mobile?'active':''} onClick={this.handleClickMobile.bind(this, true)}>Mobile News Feed</div>
                        </div>
                        <div className={this.state.is_mobile?'content-right plr20':'content-right plr7'}>
                            <div className="page_course_box feed_section">
                                <div className="feed_top_box">
                                    <div className="feed_top_left">
                                        <a href="javascript:void(0)">
                                            <img
                                                className="img_circle"
                                                src={this.props.feeditem.avata}
                                            />
                                        </a>
                                    </div>
                                    <div className="feed_top_right">
                                        <div className="feed_name user_name t-14 t-bold">
                                            <a href="/company">{this.props.feeditem.name}</a></div>
                                        <div className="feed_user_major t-12 t-normal">{this.props.feeditem.sub_name}</div>
                                    </div>
                                </div>
                                <div className="feed_mid_box">
                                    <div className="feed_content">
                                        <div className="bannerImage">
                                            {videoUrl}
                                        </div>
                                        <div className="feed_title">{this.props.feeditem.title_job}</div>
                                        <div className="job_content t-14">
                                            <ShowMoreText
                                                lines={3}
                                                more='Show more'
                                                less='Show less'
                                                anchorClass=''
                                                onClick={this.executeOnClick}
                                            >
                                                {context}
                                            </ShowMoreText>
                                        </div>
                                        <div className="feed_local">
                                            <div className="text-left t-bold t-14">
                                                <span className={"pr10"}>{this.props.feeditem.location_job}</span>
                                                <span className={"pr10"}>{this.props.feeditem.employment_job}</span>
                                                <span className={"pr10"}>{this.props.feeditem.salary_job}</span>
                                                {this.state.txt_opend}
                                            </div>
                                            <div className="btn-right">
                                                {onsite}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed_bot_box">
                                    <div className="like_box"><img src="/static/img/appimg/icon_like.png"/>
                                        &nbsp;&nbsp;&nbsp;
                                        <a className="like_btn">
                                            Like&nbsp;
                                        </a>
                                    </div>
                                    <div className="comment_box"><img
                                        src="/static/img/appimg/icon_com.png"/>&nbsp;&nbsp;&nbsp;
                                        <a>
                                            Comment&nbsp;(0)
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"btn-block clear"}>
                    <span className={"text-left"}>By clicking add Budget, you agree Versity’s <a>Term and Conditions</a>   |   <a>Help Center</a></span>
                    <div className={"text-right"}>
                        <div className={"btn btn-default btn-md mr10"} onClick={this.handleClose.bind(this)}>Cancel  </div>
                        <div className={"btn btn_confirm btn-md"} onClick={this.handleSubmit.bind(this)}>Set Budget</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BoostJob;


/** WEBPACK FOOTER **
 ** ./src/client/app/eappcomponents/commons/ppc/boostjob.js
 **/